/// <reference path="~/Areas/ProductConfiguration/Scripts/ConfigurationV2/ProductConfigurationFilterModel.js" />
/// <reference path="~/Areas/ProductConfiguration/Scripts/ConfigurationV2/ProductConfigurationFilterItem.js" />

var customFormatObjectValueId = 11859;

var AttributeCustomFormatModel = function (pageModelHndl, attributeModelHndl) {
    var that = this;
    
    that.MinLength = ko.observable(10);
    that.MaxLength = ko.observable(400);
    
    that.MinWidth = ko.observable(10);
    that.MaxWidth = ko.observable(300);

    that.Length = ko.observable(0).extend({
        required: true,

        validation: {
            validator: function(currentValue) {
                return isInteger(currentValue) && 
                    that.MinLength() <= currentValue && 
                    currentValue <= that.MaxLength();
            }
        }
    });
    that.IsLengthModified = ko.observable(false);
    
    that.Width = ko.observable(0).extend({
        required: true,      

        validation: {
            validator: function(currentValue) {
                return isInteger(currentValue) &&
                    that.MinWidth() <= currentValue &&
                    currentValue <= that.MaxWidth();
            }
        }
    }, that);
    that.IsWidthModified = ko.observable(false);

    that.IsCustomFormatOptionAvailable = ko.computed(function() {
        return attributeModelHndl.ObjectValues().some(function(objectValue) {
            return objectValue.ObjectValueId() === customFormatObjectValueId;
        });
    });
    
    that.LengthIsValid = ko.computed(function() {
        if (that.IsCustomFormatOptionAvailable() && that.IsCustomFormatSelected()) {
            that.Length.validate(that.Length());
            if (!that.Length.hasError()) {
                return true;
            }
        }
        return false;
    }, that);
    
    that.WidthIsValid = ko.computed(function() {
        if (that.IsCustomFormatOptionAvailable() && that.IsCustomFormatSelected()) {
            that.Width.validate(that.Width());
            if (!that.Width.hasError()) {
                return true;
            }
        }
        return false;
    });
    
    that.UpdateMinAndMax = function (productModel) {
        that.MinLength(productModel.CustomFormatLengthMin());
        that.MaxLength(productModel.CustomFormatLengthMax());

        that.MinWidth(productModel.CustomFormatWidthMin());
        that.MaxWidth(productModel.CustomFormatWidthMax());
    }

    that.IsCustomFormatSelected = ko.observable(false);
    that.CustomLengthCmText = ko.computed(function () {
        return new Intl.NumberFormat(navigator.language, { minimumFractionDigits: 1 }).format(that.Length() / 10) + "";
    });
    that.CustomWidthCmText = ko.computed(function () {
        return new Intl.NumberFormat(navigator.language, { minimumFractionDigits: 1 }).format(that.Width() / 10) + "";
    });

    that.CustomLengthMinText = ko.computed(function () {
        return new Intl.NumberFormat(navigator.language, { maximumFractionDigits: 0 }).format(that.MinLength()) + "";
    });

    that.CustomLengthMaxText = ko.computed(function () {
        return new Intl.NumberFormat(navigator.language, { maximumFractionDigits: 0 }).format(that.MaxLength()) + "";
    });
    
    that.CustomWidthMinText = ko.computed(function () {
        return new Intl.NumberFormat(navigator.language, { maximumFractionDigits: 0 }).format(that.MinWidth()) + "";
    });

    that.CustomWidthMaxText = ko.computed(function () {
        return new Intl.NumberFormat(navigator.language, { maximumFractionDigits: 0 }).format(that.MaxWidth()) + "";
    });

    var pushCustomFormat = function (newValue) {
        var productConfigurationFilterItem = new ProductConfigurationFilterItem(attributeModelHndl);
        pageModelHndl.pProductModel.SelectedAttributeAndExtensionValues.push(productConfigurationFilterItem);
    };
    

    that.Length.subscribe(function (newValue) {
        pushCustomFormat(newValue);
        pageModelHndl.pProductModel.UpdateProductModel();
        that.IsLengthModified(true);
    });
    
    that.Width.subscribe(function (newValue) {
        pushCustomFormat(newValue);
        pageModelHndl.pProductModel.UpdateProductModel();
        that.IsWidthModified(true);
    });
    
    function isInteger(value) {
        return value % 1 === 0;
    }
};
